// import logo from './lgo.svg';
// import './App.css';
import Tarea from './components/Tarea';
import Form from './components/Form';
import BtnFiltrar from './components/BtnFiltrar';
// useState es un gancho que permite convertir un dato de un componente en estado, la funcion devuelve el estado y una funcion para editarlo
// UseRef y useEffect se usa aqui para brindar accesibilidad a usuarios de teclado y screenreaders
import React, {useState, useRef, useEffect} from "react";
// nanoid es una libreria para asignar id unicos a elementos 
import {nanoid} from 'nanoid';
// Es una funcion que se usa aqui y en el componente Tarea, se importa desde su propio archivo
import {usePrevious} from './helpers/funcionUsePrevious'

// Objeto de funciones para los filtros, cada llave es el nombre de un filtro y cada propiedad es el comportamiento que va a tener, las funciones son para filtrar el arreglo de tareas
const MAPA_FILTROS = {
  Todas: () => true,
  Pendientes: (tarea) => !tarea.completado,
  Completadas: (tarea) => tarea.completado,
};
// Funcion que saca los nombres de las llaves del objeto y las almacena en un arreglo
const NOMBRES_FILTROS = Object.keys(MAPA_FILTROS);

function App(props) {
  // console.log(props);

  // Toma un dato (props de index.js) y devuelve arreglo con los estados y funciones para editarlos, se usa destructuring para almacenarlos en variables separadas
  const [tareas, editarTareas] = useState(props.tareas);
  // console.log(tareas);

  // Se usara el estado para alternar entre los templates de filtro de tareas pendientes, todas o completadas usando RENDERING CONDICIONAL, por defecto es todas
  const [filtro, editarFiltro] = useState("Todas");
  
  // Saca cada tarea ind (objeto) del arreglo de estados producido por useState y lo manda uno por uno como prop al componente de Tarea
  // Antes de eso, filtra las tareas para solo mostrar las que correspondan al filtro seleccionado
  const listaTareas = tareas.filter(MAPA_FILTROS[filtro]).map((tarea) => (
    <Tarea 
      nombre = {tarea.nombre}
      completado = {tarea.completado}
      id = {tarea.id}
      key = {tarea.id} 
      toggleTareaCompletada = {toggleTareaCompletada}
      eliminarTarea = {eliminarTarea}
      editTarea = {editTarea}
    />)
  );
  // KEY Siempre debe pasar una clave unica a cualquier cosa que renderice con iteración
  // console.log(listaTareas);

  // Saca cada filtro ind del arreglo y lo manda uno por uno como prop al componente de BtnFiltrar
  const listaFiltros = NOMBRES_FILTROS.map((nombre) => (
    <BtnFiltrar 
      key = {nombre} 
      nombre = {nombre}
      estaPresionado = {nombre === filtro} //devuelve un true si la condicion se cumple
      editarFiltro = {editarFiltro} //la funcion de useState se manda alla para que en el evento de onclick cambie el nombre de filtro por el que se presiona
    />)
  );
  // KEY Siempre debe pasar una clave unica a cualquier cosa que renderice con iteración
  // console.log(listaFiltros);

  // Callback Props

  // No se puede pasar informacion de un componente hijo (Form) al padre (App) como si fuera al reves usando props normales, en su lugar se escribe una funcion en el padre y la funcion se pasa como prop al hijo, a esta funcion prop se le llama callback props, asi esta funcion se va a llamar como prop en Form, se va a usar y devolvera los datos a su padre (App)
  function agregarTarea(nombre) {
    // Ya que el nombre que recibe es un string y tareas es un arreglo de objetos producido por useState, se crea un nuevo objeto para que coincidan y se pueda agregar al final del arreglo
    const nuevaTarea = {id: "tarea-" + nanoid(), nombre, completado: false};

    // La funcion para editarlas de useState tambien se puede usar para establecer una nueva, usando la sintaxis spread se le pasa el arreglo de objetos ya existente y se agrega el nuevo al inicio
    editarTareas([nuevaTarea, ...tareas]);
  }
  // console.log(tareas);

  // Funcion para detectar si se marco como completada una tarea y a cambiar su propiedad de completado a true o false, se va a llamar como prop en Tarea, se va a usar y devolvera los datos a su padre (App)
  function toggleTareaCompletada(id) {
    // Saca cada tarea ind (objeto) del arreglo de estados producido por useState, la condicion compara cada id hasta encontrar el match, usando la sintaxis spread copia el objeto, invierte el valor de la propiedad completado y devuelve el nuevo objeto, si no hay match simplemente devuelve el objeto original 
    const listaTareasActualizada = tareas.map((tarea) => {
      if (id === tarea.id) {
        return {...tarea, completado: !tarea.completado};
      }
      return tarea;
    });

    // Se usa la funcion para editarlas de useState para reemplazar la listaTareas vigente con la listaTareasActualizada
    editarTareas(listaTareasActualizada);
  }

  // Funcion para eliminar una tarea, se va a llamar como prop en Tarea, se va a usar y devolvera los datos a su padre (App)
  function eliminarTarea(id) {
    // Se usa la funcion filter para escribir un nuevo arreglo excluyendo el objeto con el match de id
    const listaTareasActualizada = tareas.filter((tarea) => tarea.id !== id);
    
    // Se usa la funcion para editarlas de useState para reemplazar la listaTareas vigente con la listaTareasActualizada
    editarTareas(listaTareasActualizada);
  }

  // Funcion para editar una tarea, se va a llamar como prop en Tarea, se va a usar y devolvera los datos a su padre (App)
  function editTarea(id, nuevoNombre) {
    // Saca cada tarea ind (objeto) del arreglo de estados producido por useState, la condicion compara cada id hasta encontrar el match, usando la sintaxis spread copia el objeto, cambia el valor de la propiedad nombre y devuelve el nuevo objeto, si no hay match simplemente devuelve el objeto original 
    const listaTareasActualizada = tareas.map((tarea) => {
      if (id === tarea.id) {
        return {...tarea, nombre: nuevoNombre};
      }
      return tarea;
    });

    // Se usa la funcion para editarlas de useState para reemplazar la listaTareas vigente con la listaTareasActualizada
    editarTareas(listaTareasActualizada);
  }

  // Variables y condiciones para mostrar en la leyenda dependiendo del filtro que esté activo
  let texto1 = "";
  let texto2 = "";

  if (filtro === "Pendientes") {
    texto1 = "pendiente";
    texto2 = "pendientes";
  } else if (filtro === "Completadas") {
    texto1 = "completada";
    texto2 = "completadas";
  } else {
    texto1 = "activa";
    texto2 = "activas";
  }

  // Accesibilidad, para pasar la referencia a esos elementos

  // useRef es un gancho (hook) que crea un objeto con una sola propiedad (current), esta puede ser una referencia a lo que sea y se puede buscar despues, sirve para referenciar a elementos del DOM
  // Estas referencias llevan el valor null porque no van a tener valor hasta que se les empareje con sus respectivos elementos
  const tareasRestantesRef = useRef(null);

  // Almacena el valor anterior de la longitud de listaTareas cuando este cambia, cada que se elimina o agrega una tarea
  const prevListaTareas = usePrevious(listaTareas.length);
  // console.log(prevListaTareas);

  // useEffect toma una funcion como parametro y la ejecuta despues que el componente (Tarea) finaliza de renderizar y posteriormente puede correr cualquier nuevo comportamiento que se quiera agregar.
  // Es util aqui para que se enfoque un elemento despues de eliminar una tarea
  useEffect(() => {
    // Se llama al objeto que useRef creo y en su propiedad current se le indica que enfoque ese elemento

    // Si se elimino un elemento
    if (prevListaTareas > listaTareas.length) {
        tareasRestantesRef.current.focus(); // Enfocar el h2 con las tareas restantes
    }
  }, [prevListaTareas]); // el segundo parametro que toma la funcion es un arreglo de variables a considerar para que solo se active la funcion cuando el valor de una de estas cambie, en este caso la cantidad de tareas activas

  // Accesibilidad termina

  return (
    <div className = "todoapp stack-large">
      <h1 className = "header">WhatsNext?</h1>
      
      <h2>¡Que no se te olvide!</h2>

      {/* Forma dinamica, se le pasa la callback prop al componente Form*/}

      <Form agregarTarea = {agregarTarea} />

      {/* Forma estatica */}

      {/* <form>
        <h3 className = "label-wrapper">
          <label htmlFor = "new-todo-input" className = "label__lg">¿Que tareas debes hacer?</label>
        </h3>

        <input type = "text" id = "new-todo-input" className = "input input__lg" name = "text" autoComplete = "off"/>

        <button type = "submit" className = "btn btn__primary btn__lg">Agregar</button>
      </form> */}

      <div className = "filters btn-group stack-exception">

        {/* Forma dinamica, iterando el arreglo de NOMBRES_FILTROS de arriba y pasando cada objeto como prop al componente BtnFiltrar*/}

        {listaFiltros}

        {/* forma dinamica, pasandole props al componente de BtnFiltrar manualmente */}

        {/* <BtnFiltrar pressed = {true} nombre = "todas" /> */}
        {/* <BtnFiltrar pressed = {false} nombre = "pendientes" /> */}
        {/* <BtnFiltrar pressed = {false} nombre = "completadas" /> */}

        {/* Forma estatica */}
        
        {/* <button type = "button" className = "btn toggle-btn" aria-pressed = "true">
          <span className = "visually-hidden">Mostrar </span>
          <span>todas</span>
          <span className = "visually-hidden"> las tareas</span>
        </button>

        <button type = "button" className = "btn toggle-btn" aria-pressed = "false">
          <span className = "visually-hidden">Mostrar </span>
          <span>Activas</span>
          <span className = "visually-hidden"> las tareas</span>
        </button>

        <button type = "button" className = "btn toggle-btn" aria-pressed = "false">
          <span className = "visually-hidden">Mostrar </span>
          <span>Completadas</span>
          <span className = "visually-hidden"> las tareas</span>
        </button> */}
      </div>
      
      {/* If anidado */}
      {/* Ref propiedad de accesibilidad, ahora ya está emparejado el elemento con la referencia */}
      {/* Accesibilidad, tabIndex -1 vuelve a un elemento enfocable con el navegador*/}
      <h2 id = "list-heading" tabIndex = "-1" ref = {tareasRestantesRef}>{listaTareas.length === 1 ? listaTareas.length + " tarea " + texto1 : listaTareas.length + " tareas " + texto2}</h2>

      <ul role = "list" className = "todo-list stack-large stack-exception" aria-labelledby = "list-heading">
        
        {/* Forma dinamica, iterando el arreglo de tareas de arriba y pasando cada objeto como prop al componente Tarea*/}

        {listaTareas}

        {/* forma dinamica, pasandole props al componente de Tarea manualmente */}

        {/* <Tarea nombre = "Comer" completado = {true} id = "todo-0" />
        <Tarea nombre = "Dormir" completado = {false} id = "todo-1" />
        <Tarea nombre = "Pistear" completado = {false} id = "todo-2" /> */}
        
        {/* Forma estatica */}

        {/* <li className = "todo stack-small">
          <div className = "c-cb">
            <input id = "todo-0" type = "checkbox" defaultChecked = {true} />

            <label className = "todo-label" htmlFor = "todo-0">Comer</label>
          </div>

          <div className = "btn-group">
            <button type = "button" className = "btn">Editar<span className = "visually-hidden">Comer</span></button>

            <button type = "button" className = "btn btn__danger">Eliminar<span className = "visually-hidden">Comer</span></button>
          </div>
        </li>

        <li className = "todo stack-small">
          <div className = "c-cb">
            <input id = "todo-1" type = "checkbox" />

            <label className = "todo-label" htmlFor = "todo-1">Dormir</label>
          </div>

          <div className = "btn-group">
            <button type = "button" className = "btn">Editar<span className = "visually-hidden">Dormir</span></button>

            <button type = "button" className = "btn btn__danger">Eliminar<span className = "visually-hidden">Dormir</span></button>
          </div>
        </li>

        <li className = "todo stack-small">
          <div className = "c-cb">
            <input id = "todo-2" type = "checkbox" />

            <label className = "todo-label" htmlFor = "todo-2">Pistear</label>
          </div>

          <div className = "btn-group">
            <button type = "button" className = "btn">Editar<span className = "visually-hidden">Pistear</span></button>

            <button type = "button" className = "btn btn__danger">Eliminar<span className = "visually-hidden">Pistear</span></button>
          </div>
        </li> */}
      </ul>
    </div>
  );
}

export default App;